import axios from "axios";
import { BASE_URL, SKOR_MODAL_PROXY_API } from "../../config";
// import toast, { ToastIcon } from "react-hot-toast";
import { toast } from "react-toastify";
import axiosInstance from "../../services/authWrapper";
import { constants } from "../../utils/constants";

export const getAllTenants = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest",
  digital_verification = "",
  bank_verified = "",
  have_guarantor = "",
  guarantor_scored = "",
  linked_property = "",
  sort_type = "",
  joined_from = "",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    var sort_type = sort_type;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    } else if (sortBy == "Name [A-Z]") {
      sort_by = "fname";
      sort_type = "asc";
    } else if (sortBy == "Name [Z-A]") {
      sort_by = "fname";
      sort_type = "desc";
    }

    var url = `${BASE_URL}/admin/tenants`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}&digital_verification=${digital_verification}&bank_verified=${bank_verified}&have_guarantor=${have_guarantor}&guarantor_scored=${guarantor_scored}&linked_property=${linked_property}&joined_from=${joined_from}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
      signal,
    });
    console.log("getAllTenants [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllTenants [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllTenants [ERROR] =>", err);
  }
};

export const searchAdminTenants = async (query, signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/search/tenant?query=${encodeURIComponent(query)}`,
      signal,
    });
    console.log("searchAdminTenants [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("searchAdminTenants [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("searchAdminTenants [ERROR] =>", err);
    return { success: false, data: [] };
  }
};

export const getAllLandlords = async (
  currentPage = 1,
  search = "",
  sortBy = "Latest",
  role = "",
  isLandlordInComp = "",
  sortType = "asc",
  agency = "all",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    var sort_type = sortType;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "createdAt";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "createdAt";
      sort_type = "asc";
    } else if (sortBy == "Name [A-Z]") {
      sort_by = "fname_companyName";
      sort_type = "asc";
    } else if (sortBy == "Name [Z-A]") {
      sort_by = "fname_companyName";
      sort_type = "desc";
    }

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlords?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${search}&sortBy=${sort_by}&sortType=${sort_type}&role=${role}&isLandlordInComp=${isLandlordInComp}&agency=${agency}`,
      signal,
    });
    console.log("getAllLandlords [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllLandlords [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllLandlords [ERROR] =>", err);
  }
};

export const getCreditTransactions = async (
  currentPage = 1,
  search = "",
  agency,
  status,
  type,
  landlord_id,
  signal = null
) => {
  try {
    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", constants.LISTING_ROWLIMIT);

    if (search) params.append("searchText", search?.trim());
    if (agency) params.append("agency", agency);
    if (status) params.append("status", status);
    if (type) params.append("type", type);
    if (landlord_id) params.append("landlord_id", landlord_id);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/getCreditsTransactions?${params.toString()}`,
      signal,
    });

    console.log("getCreditTransactions [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getCreditTransactions [REQUEST CANCELED]");
      return { status: "canceled", success: false };
    }
    console.log("getCreditTransactions [ERROR] =>", err);
  }
};

export const getAnalysisTransactions = async (
  currentPage = 1,
  search = "",
  status,
  analysis_type,
  signal = null
) => {
  try {
    // Build query params dynamically
    const params = new URLSearchParams();
    params.append("page", currentPage);
    params.append("limit", constants.LISTING_ROWLIMIT);

    if (search) params.append("searchText", search?.trim());
    if (status) params.append("status", status);
    if (analysis_type) params.append("analysis_type", analysis_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/getAnalysisLedger?${params.toString()}`,
      signal,
    });

    console.log("getAnalysisTransactions [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAnalysisTransactions [REQUEST CANCELED]");
      return { status: "canceled", success: false };
    }
    console.log("getAnalysisTransactions [ERROR] =>", err);
  }
};

export const getWorkspaceMetrics = async ({
  startDate = "",
  endDate = "",
  landlordId = "",
  workspaceId = "",
  tenantId = "",
  self_serving = undefined,
  landlord_type = "",
  signal = null
}
) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (landlordId) params.append("landlord_id", landlordId);
    if (workspaceId) params.append("workspaceId", workspaceId);
    if (tenantId) params.append("tenant_id", tenantId);
    if (self_serving) params.append("self_serving", self_serving);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landLords/workspace-metrics?${params.toString()}`,
      signal,
    });
    console.log("getWorkspaceMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWorkspaceMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getWorkspaceMetrics [ERROR] =>", err);
  }
};

export const getWorkspaceMetricsFullInfo = async (
{  startDate = "",
  endDate = "",
  landlordId = "",
  workspaceId = "",
  tenantId = "",
  self_serving = undefined,
  landlord_type = "",
  signal = null}
) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (landlordId) params.append("landlord_id", landlordId);
    if (workspaceId) params.append("workspaceId", workspaceId);
    if (tenantId) params.append("tenant_id", tenantId);
    if (self_serving) params.append("self_serving", self_serving);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landLords/workspace-metrics/full-info?${params.toString()}`,
      signal,
    });
    console.log("getWorkspaceMetricsFullInfo [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWorkspaceMetricsFullInfo [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getWorkspaceMetricsFullInfo [ERROR] =>", err);
  }
};

export const getLandlordActivityMetrics = async ({
  startDate = "",
  endDate = "",
  landlord_type = "",
  signal = null,
}) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlord-metrics/activity-metrics?${params.toString()}`,
      signal,
    });
    console.log("getLandlordActivityMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getLandlordActivityMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getLandlordActivityMetrics [ERROR] =>", err);
    return { success: false, message: err.message };
  }
};

export const getLandlordFunnelMetrics = async ({
  startDate = "",
  endDate = "",
  landlord_type = "",
  signal = null,
}) => {
  try {
    const params = new URLSearchParams();
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (landlord_type) params.append("landlord_type", landlord_type);

    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/landlord-metrics/funnel?${params.toString()}`,
      signal,
    });
    console.log("getLandlordFunnelMetrics [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getLandlordFunnelMetrics [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getLandlordFunnelMetrics [ERROR] =>", err);
    return { success: false, message: err.message };
  }
};

export const getAllProperties = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest"
) => {
  try {
    var sort_by, sort_type;
    if (sortBy == "Latest") {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    }
    var url = `${BASE_URL}/admin/properties`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
    });
    console.log("getAllProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getAllProperties [ERROR] =>", err);
  }
};

export const getAllPropertyDetails = async (
  currentPage = 1,
  searchText = "",
  type = "all",
  sortBy = "Latest",
  signal = null
) => {
  try {
    var sort_by, sort_type;
    if (sortBy == "Latest") {
      sort_by = "created_at";
      sort_type = "desc";
    } else if (sortBy == "Oldest") {
      sort_by = "created_at";
      sort_type = "asc";
    }
    var url = `${BASE_URL}/admin/properties-details`;
    if (type != "all")
      url += `?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&type=${type}&searchText=${searchText}&sortBy=${sort_by}&sortType=${sort_type}`;
    else url += `?type=${type}`;
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: url,
      signal,
    });
    console.log("getAllPropertiesDetails [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getAllPropertyDetails [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getAllProperties [ERROR] =>", err);
  }
};

export const getAllOffers = async () => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/offers`,
    });
    console.log("getAllOffers [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getAllOffers [ERROR] =>", err);
  }
};

//single functions
export const getLandlordProperties = async (landlordid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/properties/${landlordid}`,
    });
    console.log("getLandlordProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getLandlordProperties [ERROR] =>", err);
  }
};

export const getLandlordPropertyDetails = async (landlordid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/properties/property-details/${landlordid}`,
    });
    console.log("getLandlordProperties [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getLandlordProperties [ERROR] =>", err);
  }
};

export const getSingleUser = async (userid, type) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/users/${userid}?type=${type}`,
    });
    console.log("getSingleUser [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("getSingleUser [ERROR] =>", err);
  }
};

export const createOffer = async (formvalue) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/`,
      data: formvalue,
    });
    console.log("createOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("createOffer [ERROR] =>", err);
  }
};

export const editOffer = async (formvalue, offerid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/single/${offerid}`,
      data: formvalue,
    });
    console.log("editOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("editOffer [ERROR] =>", err);
  }
};

export const deleteOffer = async (offerid) => {
  try {
    const axiosRes = await axiosInstance({
      method: "DELETE",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/offers/single/${offerid}`,
    });
    console.log("deleteOffer [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    console.log("deleteOffer [ERROR] =>", err);
  }
};

export const getFeedbackDetails = async (tenantId, propId) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/landlords/get-feedback/${propId}/${tenantId}`,
    });
    return axiosRes.data;
  } catch (err) {
    console.log("getFeedbackDetails [ERROR] =>", err);
  }
};

export const getTenantKycDocs = async (tenantid) => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/tenants/get-document/${tenantid}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          responseType: "blob",
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const fetchTenantDocs = async (tenantId) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/getUploadedDocuments?tenantId=${tenantId}`,
      {},
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    console.log(err);
  }
};

export const uploadFileData = async (filedata, tenantid) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/tenants/admin/uploadDocument/${tenantid}`,
      filedata,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};

export const deleteTenantDoc = async (docId) => {
  try {
    const res = await axiosInstance.delete(
      `${BASE_URL}/tenants/deleteDoc?docId=${docId}`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res;
  } catch (err) {
    toast.error("Unable To Delete Document");
    console.log(err);
    return false;
  }
};

export const downloadTenantDoc = async (docId, file_name) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/downloadDoc?docId=${docId}`,
      {
        responseType: "blob",
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );

    // Extract filename from backend headers (if available)
    let filename = file_name ?? "download";

    const contentDisposition = res.headers["content-disposition"];
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="(.+)"/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    // Create a blob and download
    const blob = new Blob([res.data], {
      type: res.headers["content-type"],
    });

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(link.href);

    return true;
  } catch (err) {
    toast.error("Unable To Download Document");
    console.error("Download error:", err);
    return false;
  }
};


export const deleteLandlordDoc = async (docId) => {
  try {
    const res = await axiosInstance.delete(
      `${BASE_URL}/landlords/deleteDoc?docId=${docId}`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    return res;
  } catch (err) {
    toast.error("Unable To Delete Document");
    console.log(err);
    return false;
  }
};

export const loadSharedProfiles = async (tenantid) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/shared-profile/myshared-profiles/${tenantid}?profiletype=full`,
      { headers: { "Accept-Language": localStorage.getItem("i18nextLng") } }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while fetching shared profiles");
  }
};

export const landlordLoadSharedProfiles = async (landlordId) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/shared-profile/landlord-received/${landlordId}?profiletype=full`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while fetching shared profiles");
  }
};

export const getWaitlist = async (
  searchVal,
  currentPage,
  sort_type = "desc",
  signal = null
) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/waitlist/data?page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${searchVal}&sortType=${sort_type}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getWaitlist [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    toast.error("Error while fetching shared profiles");
  }
};

export const downloadDocuSignDoc = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/download/docuSign`,
      data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    toast.error("Error while downloading document!");
  }
};

export const updateUserInfo = async (formData = {}, id, type) => {
  try {
    const data = {
      formData,
      id: id,
      type,
    };
    const result = await axiosInstance.patch(
      `${BASE_URL}/users/update/info`,
      data,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    return result.data;
  } catch (error) {
    toast.error("Error while updating info!");
  }
};

export const hardDeleteTenant = async (tenant_id) => {
  try {
    const result = await axiosInstance.delete(
      `${BASE_URL}/admin/delete/tenant?tenantId=${tenant_id}`,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    if (result.data.success === true) {
      toast.success("Tenant Deleted Successfully!");
    } else {
      toast.error("Error in deleting tenant!");
    }
    return result.data;
  } catch (error) {
    console.log("error in hardDeleteTenant", error);
    toast.error("Error in deleting tenant!");
  }
};

export const loadTransactions = async (
  type,
  searchVal,
  currentPage,
  sort_type = "desc",
  sortBy = "Latest",
  signal = null
) => {
  try {
    var sort_by = sortBy;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    }
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/transaction/list?type=${type}&page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&searchText=${searchVal}&sortType=${sort_type}&sortBy=${sort_by}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("loadTransactions [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log(err);
  }
};

export const createSubAdmin = async (user_data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/users/signup`,
      user_data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    toast.success("Sub Admin Created");
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const getAdminList = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/getList`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};
export const changeUserStatus = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/users/change/status`,
      data,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const adminLogin = async (data) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/admin/user/login`, data, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
};

export const viewAsLandlord = async (tenantid) => {
  try {
    const res = await axiosInstance.post(`${BASE_URL}/admin/tenant/view`, { tenantid }, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  }
  catch (err) {
    console.log(err);
    toast.error(err.response.data.error);
  }
}

export const skorLoginAdmin = async (tenantId) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/skor/login?tenantId=${tenantId}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  }
  catch (err) {
    console.log(err);
    toast.error(err.response?.data?.errormsg || "Error logging in as admin");
    throw err;
  }
}

export const updateBulkUserInfo = async (formData = {}, ids = [], type) => {
  try {
    const data = {
      formData,
      ids: ids,
      type,
    };
    const result = await axiosInstance.patch(
      `${BASE_URL}/users/bulk/update/info`,
      data,
      {
        headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
      }
    );
  } catch (error) {
    toast.error("Error while updating info!");
  }
};

export const loadPotentialLandlords = async (
  type,
  currentPage,
  sort_type = "desc",
  sortBy = "Latest"
) => {
  try {
    var sort_by = sortBy;
    if (sortBy == "Latest" || sortBy == null) {
      sort_by = "created_at";
      sort_type = "desc";
    }
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/transaction/potentials/landlords?type=${type}&page=${currentPage}&limit=${constants.LISTING_ROWLIMIT}&sortType=${sort_type}&sortBy=${sort_by}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
  }
};
export const updateCompanyData = async (formData, landlordId) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/updateCompany/${landlordId}`,
      formData,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};
export const uploadLandlordFiles = async (formData, landlordId) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/upload/landlord/docs/${landlordId}`,
      formData,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "Content-Type": "multipart/form-data",
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};
export const fetchLandlordFiles = async (landlordId) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/fetch/landlord/docs/${landlordId}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) { }
};

export const fetchTranslations = async () => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/getTranslations`, {
      headers: {
        "Accept-Language": localStorage.getItem("i18nextLng"),
        "x-access-token": localStorage.getItem("token"),
      },
    });
    return res;
  } catch (err) { }
};

export const updateTranslations = async (data) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/updateTranslations`,
      data,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return res;
  } catch (err) {
    toast.error("Error In Uploading File!");
  }
};

export const getTenantJoinedFromList = async () => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/admin/tenants/joined-from-list`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const downloadTinkReport = async (tenant_id) => {
  try {
    const docs = await axiosInstance.get(
      `${BASE_URL}/admin/get/tink/report/${tenant_id}`,
      {
        headers: {
          "Accept-Language": localStorage.getItem("i18nextLng"),
          "x-access-token": localStorage.getItem("token"),
          responseType: "blob",
        },
      }
    );
    return docs;
  } catch (err) {
    console.log(err);
    toast.error("Error while fetching Tenant KYC Docs!");
  }
};

export const addLandlord = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${BASE_URL}/admin/create/landlord`,
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    // toast.error("Error while creating landlord!");
    throw new Error(err);
  }
};

export const editLandlord = async (data) => {
  try {
    const response = await axiosInstance.put(
      `${BASE_URL}/admin/edit/landlord`,
      data
    );
    return response;
  } catch (err) {
    console.log(err);
    // toast.error("Error while creating landlord!");
    throw new Error(err);
  }
};

export const getAllAgencies = async () => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/get/all/agencies`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const fetchAgencyDetails = async (agency_id) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/get/agency/details/${agency_id}`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const getDocumentAnalysis = async (user_id) => {
  try {
    const res = await axiosInstance.get(
      `${BASE_URL}/tenants/download/document/report/${user_id}`
    );
    return res.data;
  } catch (err) {
    console.log(err, "Error in getDocumentAnalysis");
  }
};

export const runOrchestratorAnalysis = async (formData) => {
  try {
    const result = await axiosInstance.post(SKOR_MODAL_PROXY_API, formData, {
      headers: {
        "x-access-token": localStorage.getItem("token"),
        "Content-Type": "multipart/form-data",
        "Accept-Language": localStorage.getItem("i18nextLng"),
      },
    });

    return result.data;
  } catch (error) {
    toast.error("Error while running analysis!");
    throw error;
  }
};


export const runForensicAnalysis = async (formData) => {
  try {
    const result = await axiosInstance.post(
      `${BASE_URL}/tenants/forensic-analysis`,
      formData,
      {
        headers: {
          "x-access-token": localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
          "Accept-Language": localStorage.getItem("i18nextLng"),
        },
      }
    );
    return result.data;
  } catch (error) {
    toast.error("Error while sending while!");
  }
};

export const runExperianReport = async (formData) => {
  try {
    const result = await axiosInstance.post(
      `${BASE_URL}/tenants/experian-report`,
      formData
    );
    return result.data;
  } catch (error) {
    toast.error("Error while sending while!");
  }
};

export const runForensic = async (email) => {
  try {
    const response = await axiosInstance.get(
      `${BASE_URL}/admin/runForensic?email=${email}`
    );
    return response;
  } catch (err) {
    console.log(err);
    throw new Error(err);
  }
};

export const togglerSelfServingStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerSelfServingStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerInsuranceStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerInsuranceServiceStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const togglerAffidavitStatus = async (landlordIds) => {
  try {
    const res = await axiosInstance.post(
      `${BASE_URL}/admin/togglerAffidavitServiceStatus`,
      { landlordIds: landlordIds },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );

    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    return err;
  }
};

export const getTenantDomains = async (tenant_id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/admin/get-workspace-info-for-tenant/${tenant_id}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    let serverResponse = res.data;
    return serverResponse;
  } catch (err) {
    console.log(err);
  }
};

export const getLLMCostStats = async (filters = {}) => {
  try {
    // Filter out empty strings/nulls to avoid sending empty params
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams(cleanFilters);
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/stats?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getLLMCostTenantSummaries = async (filters = {}, page = 1, limit = constants.LISTING_ROWLIMIT) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/tenants?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getLLMCostHistory = async (filters = {}, page = 1, limit = constants.LISTING_ROWLIMIT) => {
  try {
    // Filter out empty strings/nulls
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/llm-costs/history?${params.toString()}`,
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    return res.data;
  } catch (err) {
    console.log(err);
    return null;
  }
};

export const getVoiceConversations = async (filters = {}, page = 1, limit = 20, signal = null) => {
  try {
    const cleanFilters = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== "" && value !== null && value !== undefined)
    );
    const params = new URLSearchParams({ ...cleanFilters, page, limit });
    const res = await axiosInstance.get(
      `${BASE_URL}/admin/voice-conversations?${params.toString()}`,
      {
        headers: { "x-access-token": localStorage.getItem("token") },
        signal,
      }
    );
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getVoiceConversations [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getVoiceConversations [ERROR]", err);
    return null;
  }
};

export const getTenantBankStatusMetrics = async ({ start_date = "", end_date = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/bank-status?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantBankStatusMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantClaveMetrics = async ({ start_date = "", end_date = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/clave-done?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantClaveMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantDocumentMetrics = async ({ start_date = "", end_date = "", tenant_id = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tenant_id) params.append("tenant_id", tenant_id);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/tenant-docs?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantDocumentMetrics [ERROR]", err);
    return null;
  }
};

export const getOnboardingConversionMetrics = async ({
  start_date = "",
  end_date = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/onboarding-conversion?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getOnboardingConversionMetrics [ERROR]", err);
    return null;
  }
};

export const getProfileCompletionTimeMetrics = async ({ start_date = "", end_date = "", tenant_id = "", signal = null } = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    if (tenant_id) params.append("tenant_id", tenant_id);

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/profile-completion-time?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getProfileCompletionTimeMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantListWithMetrics = async ({
  page = 1,
  limit = 20,
  search = "",
  clave_done = "",
  bank_status = "",
  profile_completed = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("page", page);
    params.append("limit", limit);
    if (search) params.append("search", search);
    if (clave_done) params.append("clave_done", clave_done);
    if (bank_status) params.append("bank_status", bank_status);
    if (profile_completed) params.append("profile_completed", profile_completed);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-list?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    console.log("getTenantListWithMetrics [SUCCESS]", res.data);
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getTenantListWithMetrics [ERROR]", err);
    return null;
  }
};


export const getUserMetrics = async ({
  start_date = "",
  end_date = "",
  nationality = [],
  employment_status = [],
  landlord_id = [],
  signal = null,
} = {}) => {
  try {
    const params = new URLSearchParams();
    if (start_date) params.append("start_date", start_date);
    if (end_date) params.append("end_date", end_date);
    nationality.forEach((value) => params.append("nationality", value));
    employment_status.forEach((value) => params.append("employment_status", value));
    landlord_id.forEach((value) => params.append("landlord_id", value));

    const res = await axiosInstance.get(`${BASE_URL}/admin/tenant-metrics/user-metrics?${params.toString()}`, {
      headers: { "x-access-token": localStorage.getItem("token") },
      signal,
    });
    console.log("getUserMetrics [SUCCESS]", res.data);
    return res.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      return { status: "canceled" };
    }
    console.log("getUserMetrics [ERROR]", err);
    return null;
  }
};

export const getTenantListFilterOptions = async (signal = null) => {
  try {
    const axiosRes = await axiosInstance({
      method: "GET",
      headers: { "x-access-token": localStorage.getItem("token") },
      url: `${BASE_URL}/admin/tenant-list/filter-options`,
      signal,
    });
    console.log("getTenantListFilterOptions [SUCCESS]", axiosRes.data);
    return axiosRes.data;
  } catch (err) {
    if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      console.log("getTenantListFilterOptions [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("getTenantListFilterOptions [ERROR] =>", err);
    return { success: false, data: {} };
  }
};

export const translate = async ({translation,signal}={signal:null}) =>{
  try {
    const axiosRes = await axiosInstance({
      method: "POST",
      headers: { "x-access-token": localStorage.getItem("token") },
      data: translation,
      url: `${BASE_URL}/admin/translate`,
      signal
    });
    console.log("translate [SUCCESS]", axiosRes.data);
    return axiosRes.data
  } catch (error) {
    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
      console.log("translate [REQUEST CANCELED]");
      return { status: "canceled" };
    }
    console.log("translate [ERROR] =>", error);
    return { success: false, data: {} };
  }
}